import { CURRENT_YEAR } from "@/constants";
import { locale } from "@/config";
import ru from "./langs/ru.json";

const langs = {
  ru
};

const globals = {
  year: CURRENT_YEAR
};

const map = langs[locale || "ru"];

function l10n(key, locals = {}) {
  try {
    return map[key].replace(/%\w+%/gi, match => {
      match = match.replace(/%/g, "");
      return locals[match] || globals[match] || match;
    });
  } catch (error) {
    return key;
  }
}

l10n.plugin = {
  install(app) {
    app.prototype.$l10n = function(key, locals) {
      return l10n(key, locals);
    };
  }
};

export default l10n;
